<template>
  <div class="flex flex-col items-center justify-center min-h-[200px] text-bw-darkGrey">
    <CustomSpinner/>
    <p class="responsive-body-large font-bold">Logging you in...</p>
  </div>
</template>


<script setup lang="ts">
import { useRouter } from 'vue-router';
import { useUserStore} from "@/stores/userStore";
import { useAuth0 } from '@auth0/auth0-vue';
import { onMounted } from 'vue';
import CustomSpinner from "@/components/CustomSpinner/CustomSpinner.vue";

const router = useRouter();
const { isAuthenticated, isLoading } = useAuth0();
const userStore = useUserStore();

const redirectToStoredTarget = () => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      const stored = window.localStorage.getItem('postLoginRedirect');
      if (stored) {
        window.localStorage.removeItem('postLoginRedirect');
        router.replace(stored);
        return true;
      }
    }
  } catch (e) {
    console.warn('[Callback] Failed to read postLoginRedirect', e);
  }
  return false;
};

onMounted(async () => {
  // Wait until Auth0 finishes processing the redirect
  while (isLoading.value) {
    await new Promise((r) => setTimeout(r, 100));
  }

  // If the user is not authenticated after callback processing, do nothing.
  // (Auth0 / router guards will handle navigation or errors.)
  if (!isAuthenticated.value) return;

  // Restore session and check profile completeness
  await userStore.restoreSession();
  const complete = await userStore.checkProfileComplete();

  // If profile is complete, prefer to send the user back to their original page
  // in case onRedirectCallback did not already do so.
  if (complete) {
    const redirected = redirectToStoredTarget();
    if (redirected) return; // We already navigated.
  }

  // Only force navigation if profile is incomplete; otherwise, let
  // onRedirectCallback (set in auth.ts) send the user back to appState.targetUrl
  if (!complete) {
    router.replace('/my/account');
  }
});
</script>
